"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextLevel = exports.resetGame = exports.softResetGame = exports.createRogueTestScene = exports.genNextLevels = exports.setNextLevels = exports.getNextLevels = exports.setHouse = exports.getHouse = exports._house = void 0;
var rogueCamera_sidecar_1 = require("../camera/rogueCamera-sidecar");
var rogueMaps_sidecar_1 = require("../map/rogueMaps-sidecar");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var assert_sidecar_1 = require("../../../lib/assert-sidecar");
var rogueAanimManager_sidecar_1 = require("../anims/rogueAanimManager-sidecar");
var rogueDungeonFeatures_sidecar_1 = require("../items/rogueDungeonFeatures-sidecar");
var rogueItems_sidecar_1 = require("../items/rogueItems-sidecar");
var rogueItemsData_sidecar_1 = require("../items/rogueItemsData-sidecar");
var rogueItemsData_potions_sidecar_1 = require("../items/rogueItemsData_potions-sidecar");
var rogueItemsData_scrolls_sidecar_1 = require("../items/rogueItemsData_scrolls-sidecar");
var rogueGenHouse_1 = require("../map/rogueGenHouse");
var rogueGenHouse_difficulties_1 = require("../map/rogueGenHouse_difficulties");
var rogueGenHouse_difficulties_sidecar_1 = require("../map/rogueGenHouse_difficulties-sidecar");
var rogueGenHouse_sizes_sidecar_1 = require("../map/rogueGenHouse_sizes-sidecar");
var rogueMonstersData_sidecar_1 = require("../monsters/rogueMonstersData-sidecar");
var rogueStats_sidecar_1 = require("../ui/rogueStats-sidecar");
var rogueUiLevelSelect_sidecar_1 = require("../ui/rogueUiLevelSelect-sidecar");
var rogueUiMain_sidecar_1 = require("../ui/rogueUiMain-sidecar");
var rogueRunner_sidecar_1 = require("./rogueRunner-sidecar");
var rogueGenHouse_sizes_1 = require("../map/rogueGenHouse_sizes");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var analytics_sidecar_1 = require("../../../engine/analytics-sidecar");
exports._house = null;
var getHouse = function () {
    return exports._house;
};
exports.getHouse = getHouse;
var setHouse = function (house) {
    exports._house = house;
};
exports.setHouse = setHouse;
var _nextLevels = [];
var getNextLevels = function () {
    return _nextLevels;
};
exports.getNextLevels = getNextLevels;
var setNextLevels = function (nextLevels) {
    _nextLevels = nextLevels;
};
exports.setNextLevels = setNextLevels;
var genNextLevels = function (depth) {
    var nextLevels = [];
    for (var i = 0; i < 3; i++) {
        var houseGen = rogueGenHouse_sizes_sidecar_1.rogueGenHouse_sizes.getRandomHouseSize(depth, i * 1.33);
        var difficultyGen = rogueGenHouse_difficulties_sidecar_1.rogueGenHouse_difficulties.getRandomDifficulty(depth, i * 1.33);
        // console.log('generating next levels', houseGen, difficultyGen)
        var house = houseGen(difficultyGen());
        nextLevels.push({
            housePrototype: house,
            difficultyGen: difficultyGen,
            houseGen: houseGen,
        });
    }
    return nextLevels;
};
exports.genNextLevels = genNextLevels;
function createRogueTestScene() {
    console.log('createRogueTestScene', 'init');
    rogueMonstersData_sidecar_1.rogueMonstersData.registerAll();
    rogueItemsData_sidecar_1.rogueItemsData.registerAll();
    // ROT.RNG.setSeed(1234)
    resetGame((0, rogueGenHouse_difficulties_1.createEasyDifficulty)(), rogueGenHouse_sizes_1.createTinyHouse);
    // let map = rogueMaps.create()
    rogueCamera_sidecar_1.rogueCamera.setCameraXY(-16, -16);
}
exports.createRogueTestScene = createRogueTestScene;
function softResetGame() {
    rogueUiLevelSelect_sidecar_1.rogueUiLevelSelect.open(true);
}
exports.softResetGame = softResetGame;
function resetGame(difficulty, houseGen) {
    rogueUiMain_sidecar_1.rogueUiMain.closeAllMenus();
    rogueMonsters_sidecar_1.rogueMonsters.killAllEvenIncludingThePlayer();
    rogueMaps_sidecar_1.rogueMaps.killAll();
    var player = rogueMonsters_sidecar_1.rogueMonsters.create('@');
    rogueStats_sidecar_1.rogueStats.reset();
    rogueStats_sidecar_1.rogueStats.setMessage('Welcome to the fire academy!');
    // Create character
    // rogueUiCreateCharacter.open()
    rogueItemsData_potions_sidecar_1.rogueItemsData_potions.rollPotionVariants();
    rogueItemsData_scrolls_sidecar_1.rogueItemsData_scrolls.rollScrollVariants();
    // Create some basic items
    // for (let i = 0; i < 2; i++) {
    //   let item = rogueMaps.spawnRandomPotion()
    //   assert.notNil(item)
    //   rogueItems.transferToInventory(player, item)
    // }
    var ax = rogueItems_sidecar_1.rogueItems.create('fireaxe');
    rogueItems_sidecar_1.rogueItems.transferToInventory(player, ax);
    for (var i = 0; i < 2; i++) {
        var item = rogueMaps_sidecar_1.rogueMaps.spawnRandomScroll();
        assert_sidecar_1.assert.notNil(item);
        rogueItems_sidecar_1.rogueItems.transferToInventory(player, item);
    }
    nextLevel(false, false, difficulty, houseGen);
}
exports.resetGame = resetGame;
function nextLevel(advanceByRift, skipAnalytics, difficulty, houseGen) {
    if (advanceByRift === void 0) { advanceByRift = false; }
    if (skipAnalytics === void 0) { skipAnalytics = false; }
    if (advanceByRift) {
        rogueStats_sidecar_1.rogueStats.setMessage('You advance to the next level!');
        rogueStats_sidecar_1.rogueStats.getStats().depth++;
        if (!skipAnalytics) {
            analytics_sidecar_1.analytics.progressionComplete('house' + rogueStats_sidecar_1.rogueStats.getStats().depth);
        }
    }
    if (!skipAnalytics) {
        analytics_sidecar_1.analytics.progressionStart('house' + rogueStats_sidecar_1.rogueStats.getStats().depth);
    }
    if (rogueMaps_sidecar_1.rogueMaps.hasMap()) {
        var currentMap = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
        if (currentMap) {
            rogueMaps_sidecar_1.rogueMaps.destroyImages(currentMap);
        }
    }
    var nextMap = rogueMaps_sidecar_1.rogueMaps.createEmpty();
    var player = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
    if (!player) {
        return;
    }
    (0, exports.setHouse)(houseGen(difficulty));
    var h = (0, exports.getHouse)();
    assert_sidecar_1.assert.notNil(h);
    rogueAanimManager_sidecar_1.rogueAanimManager.addAnim((0, rogueGenHouse_1.rogueGenHouse)(h, houseGen, difficulty));
    rogueItems_sidecar_1.rogueItems.killAllButInPlayerInventory();
    rogueMonsters_sidecar_1.rogueMonsters.killAllButPlayer();
    rogueDungeonFeatures_sidecar_1.rogueDungeonFeatures.killAll();
    rogueMonsters_sidecar_1.rogueMonsters.setPos(player, 2, Math.floor(rogueDef_sidecar_1.rogueDef.screenHeight / 2) - 1);
    // Spawn rifts
    for (var i = 0; i < 3; i++) {
        var riftSpot = rogueMaps_sidecar_1.rogueMaps.findOpenGrassSpot(nextMap);
        var rift = rogueItems_sidecar_1.rogueItems.create('rift');
        rogueItems_sidecar_1.rogueItems.setPos(rift, riftSpot.x, riftSpot.y);
    }
    // Set next house options
    var level = rogueStats_sidecar_1.rogueStats.getStats().depth;
    (0, exports.setNextLevels)((0, exports.genNextLevels)(level));
    // rogueMaps.placePlayerInFirstRoom(nextMap, player)
    // rogueMaps.placeStairsInLastRoom(nextMap)
    // rogueMaps.placeItemsInRooms(nextMap, 1.0)
    // // Testing items
    // rogueMaps.placeItemsInRooms(nextMap, 1.0)
    // rogueMaps.placeItemsInRooms(nextMap, 1.0)
    // rogueMaps.placeItemsInRooms(nextMap, 1.0)
    // rogueMaps.placeMonstersInRooms(nextMap, 0.75)
    // rogueCursor.setTargetMode(ERogueTargetMode.fireball)
    rogueRunner_sidecar_1.rogueRunner.updateVision();
    rogueRunner_sidecar_1.rogueRunner.drawAll();
}
exports.nextLevel = nextLevel;
